import { IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { ISelectOption } from "shared/components/Form/Fields/select/types";
import { ChangeEvent } from "react";
import { space } from "shared/styles/constants";

const fieldCopy = copy.guestlistBlock.ticketAndPasses.create.properties;

export const getFields = ({
  disableType,
  disableTicketsTotal,
  ticketAndPassTypes = [],
  manageTicketAndPassTypes,
  handleChangeUnlimited,
}: {
  disableType?: boolean;
  disableTicketsTotal?: boolean;
  ticketAndPassTypes: ISelectOption[];
  manageTicketAndPassTypes: () => void;
  handleChangeUnlimited: (isUnlimited: boolean) => void;
}): IFormFields => [
  {
    name: "ticketAndPassType",
    type: IFieldType.select,
    label: fieldCopy.ticketAndPassType.title,
    placeholder: fieldCopy.ticketAndPassType.placeholder,
    options: ticketAndPassTypes,
    disabled: disableType,
    validation: {
      required: copy.errors.required,
    },
    fieldLink: {
      label: copy.actions.manage,
      onClick: manageTicketAndPassTypes,
    },
    style: {
      mobile: {
        gridColumn: "span 2",
      },
    },
  },
  {
    name: "ticketsTotal",
    type: IFieldType.number,
    label: fieldCopy.ticketsTotal,
    disabled: disableTicketsTotal,
    validation: {
      min: 1,
    },
    style: {
      mobile: {
        gridColumn: "span 2",
      },
    },
  },
  {
    name: "isUnlimited",
    type: IFieldType.checkbox,
    label: fieldCopy.isUnlimited,
    onChange: (event: ChangeEvent<HTMLInputElement>) => {
      handleChangeUnlimited(event.target.checked);
    },
    style: {
      marginTop: space.xl,
      mobile: {
        marginTop: 0,
        gridColumn: "span 2",
      },
    },
  },
];
